import { useEffect, useState } from "react";
import { getWorkflowModules } from "../../api";
import { ModuleDefinition } from "./types";

export interface ModuleCatalog {
    modules: ModuleDefinition[];
    byKey: Record<string, ModuleDefinition>;
    functions: string[];
}

// The catalogue only changes with a cabinet release: load it once per page load.
let cached: Promise<ModuleCatalog> | null = null;

export const loadModuleCatalog = (): Promise<ModuleCatalog> => {
    if (cached === null) {
        cached = getWorkflowModules()
            .then((response: any) => {
                const modules: ModuleDefinition[] = response?.items || [];

                return {
                    modules,
                    byKey: Object.fromEntries(modules.map((m) => [m.key, m])),
                    functions: response?.functions || [],
                };
            })
            .catch((error) => {
                cached = null;
                throw error;
            });
    }

    return cached;
};

export const useModuleCatalog = (): ModuleCatalog | null => {
    const [catalog, setCatalog] = useState<ModuleCatalog | null>(null);

    useEffect(() => {
        let alive = true;
        loadModuleCatalog().then((c) => alive && setCatalog(c)).catch(() => alive && setCatalog({ modules: [], byKey: {}, functions: [] }));

        return () => {
            alive = false;
        };
    }, []);

    return catalog;
};
